let total_accounts = 0
let temp = 100
let check = false
let total_order_image_records = 0

$(".order-image-answers").sortable({ cancel: ".crop-image-modal, .answer" })

$(document).ready(function () {
  influence_visual_feedback_and_mandatory_correct_for_interactive_page({
    fieldNeutral: "#order_image_page_neutral",
    fieldVisualFeedback: "#order_image_page_visual_feedback",
    fieldMandatoryCorrect: "#order_image_page_mandatory_correct",
  })

  if (document.getElementById("order_image_page_page_attributes_score") == undefined) {
    return
  }

  const order_image_answer_file_limits =
    $("#order_image_answer_file_limits").val() && JSON.parse($("#order_image_answer_file_limits").val())

  if ($("new_order_image_page").val() === undefined) {
    total_order_image_records = $(".order-image-answers").children().length / 2
  }

  document.addEventListener("assetSelected", function (e) {
    const { url, targetField, id, altText } = e.detail
    let asset_id = id

    if (targetField && targetField.startsWith("order_image_")) {
      const [_, objectId, languageId] = targetField.split("_")
      const filePreview = $(`.answers-for-${languageId}`).find(
        `[data-object-id="${objectId}"] .upload-order-image-preview img`,
      )
      const fileName = $(`.answers-for-${languageId}`).find(`[data-object-id="${objectId}"] #file_name`)
      const fileType = $(`.answers-for-${languageId}`).find(`[data-object-id="${objectId}"] #file_type`)
      const assetId = $(`.answers-for-${languageId}`).find(`[data-object-id="${objectId}"] .asset_id`)
      filePreview.attr("src", url)
      assetId.val(asset_id)

      const fileNameFromUrl = url.split("/").pop()
      fileName.val(fileNameFromUrl)
      fileType.val("image/jpeg") // Default to jpeg since we're getting from asset library

      // Show all parent containers properly
      filePreview.parent().css("display", "block") // .upload-order-image-preview
      filePreview.parent().parent().css("display", "block") // .photowall
      filePreview.parent().parent().parent().css("display", "block") // .add_answer

      // Prefill alt text if available
      if (altText) {
        const answerContainer = $(`.answers-for-${languageId}`).find(`[data-object-id="${objectId}"]`)
        const altTextInput = answerContainer.find(
          `input.alt_text[name*="order_image_page_alt_text"][name*="[${languageId}]"]`,
        )
        if (altTextInput.length > 0) {
          altTextInput.val(altText)
        }
      }
    } else if (targetField && targetField.startsWith("new_answer_")) {
      const languageId = targetField.split("_")[2]

      add_order_image_fields(null, window.orderImageAssociation, window.orderImageFieldsData, "new")

      const lastAnswer = $(".answers-for-" + languageId)
        .children()
        .last()
      const filePreview = lastAnswer.find(".upload-order-image-preview img")
      const fileName = lastAnswer.find("#file_name")
      const fileType = lastAnswer.find("#file_type")
      const assetId = lastAnswer.find(".asset_id")

      filePreview.attr("src", url)
      assetId.val(asset_id)
      const fileNameFromUrl = url.split("/").pop()
      fileName.val(fileNameFromUrl)
      fileType.val("image/jpeg")

      // Show all parent containers properly
      filePreview.parent().css("display", "block") // .upload-order-image-preview
      filePreview.parent().parent().css("display", "block") // .photowall
      lastAnswer.css("display", "block") // outer container

      // Prefill alt text if available
      if (altText) {
        // Find the alt text input in the last answer (for new answers, object_id is replaced with total_accounts)
        const altTextInput = lastAnswer.find(
          `input.alt_text[name*="order_image_page_alt_text"][name*="[${languageId}]"]`,
        )
        if (altTextInput.length > 0) {
          altTextInput.val(altText)
        }
      }
    }

    window.orderImageFieldsData = null
    window.useAssetLibrary = null
    window.orderImageAssociation = null
    window.orderImageView = null

    $("input, button, a").prop("disabled", false)

    document.body.offsetHeight
  })

  $(document).on("click", ".add-order-image-answer", function (e) {
    e.preventDefault()
    const $link = $(this)
    const useAssetLibrary = $link.data("use-asset-library")
    const fields = $("#fields_data_" + $("#page_language_selection").val()).val()

    if (useAssetLibrary) {
      window.orderImageFieldsData = fields
      window.useAssetLibrary = true
      window.orderImageAssociation = $link.data("association")
      window.orderImageView = $link.data("view")
    } else {
      window.orderImageFieldsData = null
      window.useAssetLibrary = false
      window.orderImageAssociation = null
      window.orderImageView = null

      order_image_preview()
    }
    return false
  })
})

function order_image_preview() {
  let language = $("#page_language_selection").val()
  let file_preview = $(".answers-for-" + language)
    .children()
    .last()
    .find(".photowall .upload-order-image-preview img")
  let file_name = $(".answers-for-" + language)
    .children()
    .last()
    .find("#file_name")
  let file_type = $(".answers-for-" + language)
    .children()
    .last()
    .find("#file_type")

  const useAssetLibrary = $(".answers-for-" + language)
    .children()
    .last()
    .find(".add-answer-container")
    .data("use-asset-library")
  if (!useAssetLibrary) {
    const fileInput = $(".answers-for-" + language)
      .children()
      .last()
      .find(".order-img-preview")

    fileInput.off("change")

    fileInput.change(function (event) {
      let file, input, reader
      $(".answers-for-" + language)
        .children()
        .last()
        .find(".upload-order-image-preview")
        .css("display", "block")
      $(".answers-for-" + language)
        .children()
        .last()
        .css("display", "block")
      input = $(event.currentTarget)
      file = input[0].files[0]
      const order_image_answer_file_limits =
        $("#order_image_answer_file_limits").val() && JSON.parse($("#order_image_answer_file_limits").val())
      if (fileSizeNotInLimit(file, event, ".edit-banner-modal", order_image_answer_file_limits["image"])) {
        input.val("")
        check_last_order_image_answer()
        return
      } else {
        reader = new FileReader()
        reader.onload = function (e) {
          let image_base64
          image_base64 = e.target.result
          file_preview.attr("src", image_base64)

          make_order_image_cropbox()
          $(file_name).val(file.name)
          $(file_type).val(file.type)
        }
        reader.readAsDataURL(file)
      }
    })

    fileInput.click()
  }
}

window.remove_order_image_fields = function (link) {
  const $container = $(link).parent().parent()
  const answerId = $container.find("#answer-id").val()

  if (answerId) {
    // This is an existing answer - need to mark for deletion across ALL language tabs
    // Find all instances of this answer ID across all language tabs
    $(`.add_answer`).each(function () {
      const $answer = $(this)
      const currentAnswerId = $answer.find("#answer-id").val()

      if (currentAnswerId === answerId) {
        // Mark this instance for destruction
        $answer.find('input[type="hidden"][name*="[_destroy]"]').val(1)
        // Remove the DOM element
        $answer.parent().remove()
      }
    })
  } else {
    // This is a new (unsaved) answer - just remove the DOM element
    $(link).siblings().val(1)
    $container.remove()
  }

  total_order_image_records--
}

function check_last_order_image_answer() {
  if ($(".order-image-answers").children().last().find(".order-img-preview").val() === "") {
    $(".order-image-answers").children().last().remove()
    total_order_image_records--
  }
}

window.add_order_image_fields = function (link, association, fields_to_clone, view) {
  if (!window.useAssetLibrary) {
    check_last_order_image_answer()
  }

  const $link = $(link)

  if (window.useAssetLibrary) {
    association = window.orderImageAssociation || association
    view = window.orderImageView || view
    fields_to_clone = window.orderImageFieldsData
  }

  const useAssetLibrary =
    window.useAssetLibrary || $link.data("use-asset-library") || $link.closest(".add-answer-container").length > 0

  // Try to get fields data in this order:
  // 1. From the passed fields_to_clone parameter
  // 2. From the stored global variable (only if using asset library)
  // 3. From the hidden input field
  // 4. From the container's data attribute
  if (!fields_to_clone) {
    fields_to_clone =
      window.orderImageFieldsData ||
      $("#fields_data_" + $("#page_language_selection").val()).val() ||
      $link.closest(".fields-data-container").data("fields") ||
      $link.data("fields")
  }

  if (!fields_to_clone) {
    console.error("No fields data available to clone. Sources checked:", {
      useAssetLibrary,
      hasGlobalData: !!window.orderImageFieldsData,
      hasHiddenField: !!$("#fields_data_" + $("#page_language_selection").val()).val(),
      hasContainerData: !!$link.closest(".fields-data-container").data("fields"),
      hasLinkData: !!$link.data("fields"),
      hasStoredData: !!window.orderImageFieldsData,
      storedDataLength: window.orderImageFieldsData ? window.orderImageFieldsData.length : 0,
    })
    return
  }

  if (total_order_image_records < 4) {
    total_order_image_records++
  }

  if (view === "new") {
    total_accounts++
  } else {
    temp++
    total_accounts = temp
  }

  let div = document.getElementById("editCropOrderImageModal")
  if (div !== null) {
    div.parentNode.removeChild(div)
  }

  let regexp = new RegExp("new_" + association, "g")
  let regexp2 = new RegExp("new_alt_text", "g")
  let language = $("#page_language_selection").val()
  let course_default_language = $("#course_default_language").val()
  let add_answer =
    course_default_language == language ||
    $(".answers-for-" + language)
      .children()
      .find(".add_answer").length <
      $(".answers-for-" + course_default_language)
        .children()
        .find(".add_answer").length

  if (add_answer) {
    try {
      const uniqueId = "answer_" + Date.now()
      const fieldsWithUniqueId = fields_to_clone
        .replace(regexp, total_accounts)
        .replace(regexp2, total_accounts)
        .replace(/class="mc-inner add_answer"/g, `class="mc-inner add_answer" id="${uniqueId}"`)

      $(".answers-for-" + language).append(fieldsWithUniqueId)

      if (!useAssetLibrary) {
        const lastAnswer = $(".answers-for-" + language)
          .children()
          .last()
        lastAnswer.css("display", "block")

        const fileInput = lastAnswer.find(".order-img-preview")
        fileInput.off("change")

        fileInput.change(function (event) {
          let file, input, reader
          const preview = lastAnswer.find(".upload-order-image-preview")
          const filePreview = preview.find("img")
          const fileName = lastAnswer.find("#file_name")
          const fileType = lastAnswer.find("#file_type")

          preview.css("display", "block")
          input = $(event.currentTarget)
          file = input[0].files[0]

          const order_image_answer_file_limits =
            $("#order_image_answer_file_limits").val() && JSON.parse($("#order_image_answer_file_limits").val())
          if (fileSizeNotInLimit(file, event, ".edit-banner-modal", order_image_answer_file_limits["image"])) {
            input.val("")
            check_last_order_image_answer()
            return
          } else {
            reader = new FileReader()
            reader.onload = function (e) {
              let image_base64 = e.target.result
              filePreview.attr("src", image_base64)

              make_order_image_cropbox()
              fileName.val(file.name)
              fileType.val(file.type)
            }
            reader.readAsDataURL(file)
          }
        })

        // Trigger the file input click after a short delay
        setTimeout(() => {
          if ($("#asset_library_allowed").val() == "false") {
            fileInput.click()
          }
        }, 100)
      } else {
        // For asset library, just show the container
        const lastAnswer = $(".answers-for-" + language)
          .children()
          .last()
        lastAnswer.find(".upload-order-image-preview").css("display", "block")
        lastAnswer.css("display", "block")
      }
    } catch (e) {
      console.error("Error adding new answer fields:", e)
    }
  } else {
    alert("Can't add more answers in this language as it exceeds the number of answers added in default language")
  }

  // Only clear the global variables if we're not using asset library
  // This allows multiple additions when using asset library
  if (!useAssetLibrary) {
    window.orderImageFieldsData = null
    window.useAssetLibrary = null
    window.orderImageAssociation = null
    window.orderImageView = null
  }
}

function make_order_image_cropbox() {
  let cropbox, croppie_ipad
  cropbox = "#order_edit_image_cropbox"
  let language = $("#page_language_selection").val()
  $(cropbox).attr(
    "src",
    $(".answers-for-" + language)
      .children()
      .last()
      .find(".photowall .upload-order-image-preview img")
      .attr("src"),
  )

  $(".upload-preview").removeClass("upload-preview")
  $(".answers-for-" + language)
    .children()
    .last()
    .find(".upload-order-image-preview")
    .addClass("upload-preview")
  $("#editCropOrderImageModal").find(".upload-order-image-preview").addClass("upload-preview")
  $("#editCropOrderImageModal").find(".upload-order-image-preview").attr("src", $(cropbox).attr("src"))

  croppie_ipad = $(".croppie-ipad").croppie({
    viewport: {
      width: 400,
      height: 400,
    },
  })

  $("#editCropOrderImageModal").openModal()
  $(".back-order-image-page").click(function () {
    const modal = $(this).attr("href")
    $(".darkroom-image-container").remove()
    $(modal).closeModal()
  })

  $(".save-cropped-image-btn").click(function () {
    const src = croppie_ipad.get(0).src
    let format = croppie_ipad.get(0).src.split(";")[0].split("/")[1]
    if (!format) {
      format = "jpeg"
    }
    croppie_ipad
      .croppie("result", {
        type: "canvas",
        size: "original",
        format: format,
        quality: "0.99",
      })
      .then(function (response) {
        $(".upload-preview img").attr("src", response)
      })
  })
}

$("#order_image_page_mandatory_correct").on("click", function () {
  if ($("#order_image_page_mandatory_correct").is(":checked")) {
    if (!$("#order_image_page_feedback").is(":checked")) {
      $("#order_image_page_feedback").click()
    }
    if ($("#order_image_page_neutral").is(":checked")) {
      $("#order_image_page_neutral").click()
    }
  }
})

$("#order_image_page_neutral").on("click", function () {
  influence_visual_feedback_and_mandatory_correct_for_interactive_page({
    fieldNeutral: "#order_image_page_neutral",
    fieldVisualFeedback: "#order_image_page_visual_feedback",
    fieldMandatoryCorrect: "#order_image_page_mandatory_correct",
  })
})

$("#order_image_page_feedback").on("click", function () {
  if (!$("#order_image_page_feedback").is(":checked")) {
    if ($("#order_image_page_mandatory_correct").is(":checked")) {
      $("#order_image_page_mandatory_correct").click()
    }
  }
})

let feedback, neutral, mandatory_correct, visual_feedback
let description_multi = {}
let name_multi = {}
let info_multi = {}
let explanation_multi = {}
let correct_explanation_multi = {}
let incorrect_explanation_multi = {}

function set_order_image_page_variables() {
  if ($("#order_image_page_feedback").is(":checked")) {
    feedback = 1
  } else {
    feedback = 0
  }

  if ($("#order_image_page_neutral").is(":checked")) {
    neutral = 1
  } else {
    neutral = 0
  }

  if ($("#order_image_page_mandatory_correct").is(":checked")) {
    mandatory_correct = 1
  } else {
    mandatory_correct = 0
  }

  if ($("#order_image_page_visual_feedback").is(":checked")) {
    visual_feedback = 1
  } else {
    visual_feedback = 0
  }

  const ref = $('textarea[id^="order_image_page_page_attributes_description_multi"]')
  for (let i = 0, len = ref.length; i < len; i++) {
    const answer = ref[i]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = CKEDITOR.instances[id].getData()
    description_multi[key] = val
  }

  const ref1 = $('input[id^="order_image_page_page_attributes_name_multi"]')
  for (let j = 0, len1 = ref1.length; j < len1; j++) {
    const answer = ref1[j]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = $(answer).val()
    name_multi[key] = val
  }

  const ref2 = $('textarea[id^="order_image_page_page_attributes_info_multi"]')
  for (let k = 0, len2 = ref2.length; k < len2; k++) {
    const answer = ref2[k]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = CKEDITOR.instances[id].getData()
    info_multi[key] = val
  }

  const ref3 = $('textarea[id^="order_image_page_explanation_multi"]')
  for (let k = 0, len3 = ref3.length; k < len3; k++) {
    const answer = ref3[k]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = CKEDITOR.instances[id].getData()
    explanation_multi[key] = val
  }

  const ref4 = $('textarea[id^="order_image_page_correct_explanation_multi"]')
  for (let k = 0, len4 = ref4.length; k < len4; k++) {
    const answer = ref4[k]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = CKEDITOR.instances[id].getData()
    correct_explanation_multi[key] = val
  }

  const ref5 = $('textarea[id^="order_image_page_incorrect_explanation_multi"]')
  for (let k = 0, len5 = ref5.length; k < len5; k++) {
    const answer = ref5[k]
    const id = $(answer).attr("id")
    const key = id.substring(id.lastIndexOf("_") + 1)
    const val = CKEDITOR.instances[id].getData()
    incorrect_explanation_multi[key] = val
  }
}

$('form[id="new_order_image_page"]').submit(function (e) {
  e.preventDefault()
  disablePageSubmit()
  const asset_library_allowed = $("#asset_library_allowed").val() == "true"
  $("#loading-modal").openModal({ dismissible: false })
  if ($("#order_image_page_page_attributes_name").val() === "") {
    alert("Name can't be blank")
    enablePageSubmit("Create")
    return false
  }
  let images = []
  let ignore_js = $("#page_convert_to").val() !== ""

  let order_image_answers = $(".order-image-answers .add_answer")
  for (let i = 0; order_image_answers[i]; i++) {
    const $answer = $(order_image_answers[i])
    const asset_id = $answer.find(".upload-order-image-preview .asset_id").val()

    if (
      $answer.find(".upload-order-image-preview img").attr("src") !== undefined &&
      asset_library_allowed &&
      asset_id
    ) {
      // this is for asset library
      const answer = $answer.find(".answer").val()

      images.push({
        base64: "",
        file_name: "",
        file_type: "",
        language_id: $answer.find("#language_id").val(),
        answer: answer,
        asset_id: asset_id,
        alt_text: $answer.find(".alt_text").val(),
      })
    } else if ($answer.find(".upload-order-image-preview img").attr("src") !== undefined) {
      // this is for direct upload
      const answer = $answer.find(".answer").val()

      images.push({
        base64: $answer
          .find(".upload-order-image-preview img")
          .attr("src")
          .replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, ""),
        file_name: $answer.find("#file_name").val(),
        file_type: $answer.find("#file_type").val(),
        language_id: $answer.find("#language_id").val(),
        answer: answer,
        alt_text: $answer.find(".alt_text").val(),
      })
    }
  }

  set_order_image_page_variables()

  let data = {
    "page[convert_to]": $("#page_convert_to").val(),
    page_to_convert: $("#page_to_convert").val(),
    "order_image_page[custom_images]": images,
    "order_image_page[page_attributes][name_multi]": name_multi,
    "order_image_page[page_attributes][description_multi]": description_multi,
    "order_image_page[page_attributes][info_multi]": info_multi,
    "order_image_page[page_attributes][score]": $("#order_image_page_page_attributes_score").val(),
    "order_image_page[page_attributes][exclude_from_total_score]": $("#exclude-from-total-score").is(":checked")
      ? "1"
      : "",
    "order_image_page[page_attributes][status]": $("#order_image_page_page_attributes_status").val(),
    "order_image_page[page_attributes][chapter_id]": $("#order_image_page_page_attributes_chapter_id").val(),
    "order_image_page[page_attributes][timeout_in_seconds]": $(
      "#order_image_page_page_attributes_timeout_in_seconds",
    ).val(),
    "order_image_page[explanation_multi]": explanation_multi,
    "order_image_page[correct_explanation_multi]": correct_explanation_multi,
    "order_image_page[incorrect_explanation_multi]": incorrect_explanation_multi,
    authenticity_token: $("input[name=authenticity_token]").val(),
  }

  if ($("#order_image_page_feedback").length > 0) {
    data["order_image_page[feedback]"] = feedback
  }

  if ($("#order_image_page_neutral").length > 0) {
    data["order_image_page[neutral]"] = neutral
  }

  if ($("#order_image_page_mandatory_correct").length > 0) {
    data["order_image_page[mandatory_correct]"] = mandatory_correct
  }

  if ($("#order_image_page_visual_feedback").length > 0) {
    data["order_image_page[visual_feedback]"] = visual_feedback
  }

  $.ajax({
    type: "POST",
    url: $(this).attr("action") + ".json",
    enctype: "multipart/form-data",
    data: data,
  })
    .done(function (data, textStatus, jqXHR) {
      if (!ignore_js) {
        window.safeRedirect(data["redirect_to"])
      } else {
        window.safeRedirect(data["convert_to"])
      }
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      alert(jqXHR.responseText)
      $("input[type='submit']").val("Create")
      $("input[type='submit']").attr("disabled", false)
      $("#loading-modal").closeModal()
    })
  return false
})

$('form[id^="edit_order_image_page_"]').submit(function (e) {
  e.preventDefault()
  disablePageSubmit()
  $("#loading-modal").openModal({ dismissible: false })
  if ($("#order_image_page_page_attributes_name").val() === "") {
    alert("Name can't be blank")
    enablePageSubmit("Update")
    return false
  }
  let images = []
  let old_images = []
  let ignore_js = $("#page_convert_to").val() !== ""
  const asset_library_allowed = $("#asset_library_allowed").val() == "true"

  let order_image_answers = $(".order-image-answers .add_answer")
  for (let i = 0; order_image_answers[i]; i++) {
    const $answer = $(order_image_answers[i])
    const asset_id = $answer.find(".upload-order-image-preview .asset_id").val()
    if (
      $answer.find(".upload-order-image-preview img").attr("src") !== undefined &&
      $answer.find(".upload-order-image-preview img").attr("src").indexOf("base64") !== -1
    ) {
      // this is direct upload
      const answer = $answer.find(".answer").val()

      images.push({
        base64: $answer
          .find(".upload-order-image-preview img")
          .attr("src")
          .replace(/^data:image\/(png|jpg|jpeg|gif);base64,/, ""),
        file_name: $answer.find("#file_name").val(),
        file_type: $answer.find("#file_type").val(),
        language_id: $answer.find("#language_id").val(),
        answer: answer,
        alt_text: $answer.find(".alt_text").val(),
      })
    } else if (
      $answer.find(".upload-order-image-preview img").attr("src") !== undefined &&
      asset_library_allowed &&
      asset_id
    ) {
      // this is for asset library
      const answer = $answer.find(".answer").val()

      images.push({
        base64: "",
        file_name: "",
        file_type: "",
        language_id: $answer.find("#language_id").val(),
        answer: answer,
        asset_id: asset_id,
        alt_text: $answer.find(".alt_text").val(),
      })
    } else if ($answer.find(".upload-order-image-preview img").attr("src") !== undefined) {
      // this is existing image
      const answer = $answer.find(".answer").val()

      if ($answer.find("#answer-id").val()) {
        old_images.push({
          id: $answer.find("#answer-id").val(),
          language_id: $answer.find("#language_id").val(),
          answer: answer,
          alt_text: $answer.find(".alt_text").val(),
        })
      }
    }
  }

  set_order_image_page_variables()

  let data = {
    "page[convert_to]": $("#page_convert_to").val(),
    page_to_convert: $("#page_to_convert").val(),
    "order_image_page[custom_images]": images,
    "order_image_page[old_images]": old_images,
    "order_image_page[page_attributes][name_multi]": name_multi,
    "order_image_page[page_attributes][description_multi]": description_multi,
    "order_image_page[page_attributes][info_multi]": info_multi,
    "order_image_page[page_attributes][score]": $("#order_image_page_page_attributes_score").val(),
    "order_image_page[page_attributes][exclude_from_total_score]": $("#exclude-from-total-score").is(":checked")
      ? "1"
      : "",
    "order_image_page[page_attributes][status]": $("#order_image_page_page_attributes_status").val(),
    "order_image_page[page_attributes][chapter_id]": $("#order_image_page_page_attributes_chapter_id").val(),
    "order_image_page[page_attributes][id]": $("#order_image_page_page_attributes_id").val(),
    "order_image_page[page_attributes][timeout_in_seconds]": $(
      "#order_image_page_page_attributes_timeout_in_seconds",
    ).val(),
    "order_image_page[explanation_multi]": explanation_multi,
    "order_image_page[correct_explanation_multi]": correct_explanation_multi,
    "order_image_page[incorrect_explanation_multi]": incorrect_explanation_multi,
    authenticity_token: $("input[name=authenticity_token]").val(),
    _method: "patch",
  }

  if ($("#order_image_page_feedback").length > 0) {
    data["order_image_page[feedback]"] = feedback
  }

  if ($("#order_image_page_neutral").length > 0) {
    data["order_image_page[neutral]"] = neutral
  }

  if ($("#order_image_page_mandatory_correct").length > 0) {
    data["order_image_page[mandatory_correct]"] = mandatory_correct
  }

  if ($("#order_image_page_visual_feedback").length > 0) {
    data["order_image_page[visual_feedback]"] = visual_feedback
  }

  $.ajax({
    type: "POST",
    url: $(this).attr("action") + ".json",
    enctype: "multipart/form-data",
    data: data,
  })
    .done(function (data, textStatus, jqXHR) {
      if (!ignore_js) {
        window.safeRedirect(data["redirect_to"])
      } else {
        window.safeRedirect(data["convert_to"])
      }
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      alert(jqXHR.responseText)
      $("input[type='submit']").val("Update")
      $("input[type='submit']").attr("disabled", false)
      $("#loading-modal").closeModal()
    })
  return false
})

window.add_order_image_phone_fields = function (link, association, fields_to_clone, view) {
  // Don't check last answer when using asset library to allow multiple additions
  if (!window.useAssetLibrary) {
    check_last_order_image_answer()
  }

  const $link = $(link)

  // Use stored data if available (from asset library)
  if (window.useAssetLibrary) {
    association = window.orderImageAssociation || association
    view = window.orderImageView || view
    fields_to_clone = window.orderImageFieldsData
  }

  // Check if we're using asset library - try multiple sources
  const useAssetLibrary =
    window.useAssetLibrary || $link.data("use-asset-library") || $link.closest(".add-answer-container").length > 0

  // Try to get fields data in this order:
  // 1. From the passed fields_to_clone parameter
  // 2. From the stored global variable (only if using asset library)
  // 3. From the hidden input field (only if using asset library)
  // 4. From the container's data attribute
  if (!fields_to_clone) {
    if (useAssetLibrary) {
      fields_to_clone =
        window.orderImageFieldsData ||
        $("#fields_data_" + $("#page_language_selection").val()).val() ||
        $link.closest(".fields-data-container").data("fields")
    } else {
      fields_to_clone = $link.data("fields")
    }
  }

  if (!fields_to_clone) {
    console.error("No fields data available to clone. Sources checked:", {
      useAssetLibrary,
      hasGlobalData: !!window.orderImageFieldsData,
      hasHiddenField: !!$("#fields_data_" + $("#page_language_selection").val()).val(),
      hasContainerData: !!$link.closest(".fields-data-container").data("fields"),
      hasLinkData: !!$link.data("fields"),
      hasStoredData: !!window.orderImageFieldsData,
      storedDataLength: window.orderImageFieldsData ? window.orderImageFieldsData.length : 0,
    })
    return
  }

  if (total_order_image_records < 4) {
    total_order_image_records++
  }

  if (view === "new") {
    total_accounts++
  } else {
    temp++
    total_accounts = temp
  }

  let div = document.getElementById("editCropOrderImageModal")
  if (div !== null) {
    div.parentNode.removeChild(div)
  }

  let regexp = new RegExp("new_" + association, "g")
  let regexp2 = new RegExp("new_alt_text", "g")
  let language = $("#page_language_selection").val()
  let course_default_language = $("#course_default_language").val()
  let add_answer =
    course_default_language == language ||
    $(".answers-for-" + language)
      .children()
      .find(".add_answer").length <
      $(".answers-for-" + course_default_language)
        .children()
        .find(".add_answer").length

  if (add_answer) {
    try {
      const uniqueId = "phone_answer_" + Date.now()
      const fieldsWithUniqueId = fields_to_clone
        .replace(regexp, total_accounts)
        .replace(regexp2, total_accounts)
        .replace(
          /class="mc-inner add_answer"/g,
          `class="mc-inner add_answer order-image-phone-answer" id="${uniqueId}"`,
        )

      $(".answers-for-" + language).append(fieldsWithUniqueId)

      if (!useAssetLibrary) {
        order_image_phone_preview()
      } else {
        const lastAnswer = $(".answers-for-" + language)
          .children()
          .last()
        lastAnswer.find(".upload-order-image-preview").css("display", "block")
        lastAnswer.css("display", "block")
      }
    } catch (e) {
      console.error("Error adding new phone answer fields:", e)
    }
  } else {
    alert("Can't add more answers in this language as it exceeds the number of answers added in default language")
  }

  // Only clear the global variables if we're not using asset library
  // This allows multiple additions when using asset library
  if (!useAssetLibrary) {
    window.orderImageFieldsData = null
    window.useAssetLibrary = null
    window.orderImageAssociation = null
    window.orderImageView = null
  }
}

function order_image_phone_preview() {
  let language = $("#page_language_selection").val()
  let file_preview = $(".answers-for-" + language)
    .children()
    .last()
    .find(".photowall .upload-order-image-preview img")
  let file_name = $(".answers-for-" + language)
    .children()
    .last()
    .find("#file_name")
  let file_type = $(".answers-for-" + language)
    .children()
    .last()
    .find("#file_type")

  // Only set up file input change handler if we're not using asset library
  const useAssetLibrary = $(".answers-for-" + language)
    .children()
    .last()
    .find(".add-answer-container")
    .data("use-asset-library")
  if (!useAssetLibrary) {
    const fileInput = $(".answers-for-" + language)
      .children()
      .last()
      .find(".order-img-preview")

    // Remove any existing change handlers
    fileInput.off("change")

    // Add new change handler
    fileInput.change(function (event) {
      let file, input, reader
      $(".answers-for-" + language)
        .children()
        .last()
        .find(".upload-order-image-preview")
        .css("display", "block")
      $(".answers-for-" + language)
        .children()
        .last()
        .css("display", "block")
      input = $(event.currentTarget)
      file = input[0].files[0]
      const order_image_answer_file_limits =
        $("#order_image_answer_file_limits").val() && JSON.parse($("#order_image_answer_file_limits").val())
      if (fileSizeNotInLimit(file, event, ".edit-banner-modal", order_image_answer_file_limits["image"])) {
        input.val("")
        check_last_order_image_answer()
        return
      } else {
        reader = new FileReader()
        reader.onload = function (e) {
          let image_base64
          image_base64 = e.target.result
          file_preview.attr("src", image_base64)

          make_order_image_cropbox()
          $(file_name).val(file.name)
          $(file_type).val(file.type)
        }
        reader.readAsDataURL(file)
      }
    })

    // Only trigger click if we're not using asset library
    fileInput.click()
  }
}
